import { render, staticRenderFns } from "./newMap.vue?vue&type=template&id=871386c4&scoped=true&"
import script from "./newMap.vue?vue&type=script&lang=js&"
export * from "./newMap.vue?vue&type=script&lang=js&"
import style0 from "./newMap.vue?vue&type=style&index=0&id=871386c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "871386c4",
  null
  
)

export default component.exports